import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import OtherService from '../services/Other';
import { Col, Container, Row } from 'react-bootstrap'
import Loader from '../component/Loader'
import { BreadCrumbSecttion } from '../component/BreadCrumbSecttion'
import ColorCalender from '../assets/images/calendar.png'
import newsDefaultImage from '../assets/images/newsDefault.png'
import LocationPin from '../assets/images/map-pin.png'

const HierarchyEventDetails = () => {
  const { eventId } = useParams();
  const [isEventListAll, setIsEventListAll] = useState([])
  const [isEventListData, setIsEventListData] = useState(false)
  const [loading, setLoading] = useState(true);
  //Format Date
  const formatDate = (date) => {
    const dateTime = new Date(date);
    return dateTime.toLocaleString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hour12: true,
    });
  };
  useEffect(() => {
    const hierarchiesEventDetailsFetch = async () => {
      try {
        const token = localStorage.getItem('access_token');
        const hierarchiesEventDetailsFetchResponse = await OtherService.eventDetailsByHierarchyId(token, eventId)
        
        if (hierarchiesEventDetailsFetchResponse.error == false && hierarchiesEventDetailsFetchResponse.data.length > 0) {

          setIsEventListAll(hierarchiesEventDetailsFetchResponse.data[0])
          setIsEventListData(false)
          setLoading(false)
        }
        else {
          setLoading(false)
          setIsEventListData(true)

        }
      }
      catch (error) {
        console.error('hierarchiesEventDetailsFetch')
      }

    }
    hierarchiesEventDetailsFetch()
  }, [])
  return (
    <>
      {loading && <Loader />}
      <BreadCrumbSecttion
        pageTitle={isEventListAll?.name}
        currentPageName={isEventListAll?.name} />
      <section className='padTop50'>
        <div className="dashboard-details">
          <Container>
            {isEventListData && (
              <Row>
                <Col xs={12}>
                  <div className='noDataMsg'>No data found!</div>
                </Col>
              </Row>
            )}
            {!isEventListData &&
              <Row className='justify-content-center'>
                <Col xs={12} md={6} lg={10}>
                  <div className='eventDetailsWrap'>
                    <div className='eventDetailsWrapImg'>
                      <img src={isEventListAll?.contentFilesThumbnailImage == null ? newsDefaultImage : isEventListAll.contentFilesThumbnailImage} />
                    </div>
                    <div className='eventDetailsWrapText mt-3'>
                      
                      <div className='upComingEventTime'>
                        <img src={ColorCalender} alt='image' /> <b>Start:</b> {formatDate(isEventListAll?.start_date)}
                      </div>
                      <div className='upComingEventTime'>
                        <img src={ColorCalender} alt='image' /> <b>End:</b> {formatDate(isEventListAll?.end_date)}
                      </div>
                      <div className='upComingEventPlace'>
                        <img src={LocationPin} alt='image' /><b> Place:</b> {`${isEventListAll?.city}, ${isEventListAll?.state}`}
                      </div>
                      <p className='eeventTitle'>{isEventListAll?.name}</p>
                      <p className='eeventDesc'>{isEventListAll?.description}</p>
                    </div>
                  </div>
                </Col>
              </Row>
            }

          </Container>
        </div>
      </section>
    </>
  )
}

export default HierarchyEventDetails